<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <alert-box ref="alertBox" class="spacer-bottom-m" />

        <div class="z-title z-title--small spacer-bottom-l">
          Pagar {{ periodName }} com cartão de crédito
        </div>

        <contract-full-amount />

        <div v-if="creditCard && !setupFinished">
          <label class="z-dropdown-input">
            Número de parcelas

            <div class="z-dropdown-input__input-wrapper">
              <select class="z-dropdown-input__input" v-model="installment">
                <option selected disabled :value="null">
                  Selecione o número de parcelas
                </option>

                <option v-for="index in 12" :value="index" :key="index">
                  {{ index }} {{ pluralizeInstallments(index) }} de
                  {{ (currentContract.remaining_value / index) | formatCurrency }}
                </option>
              </select>
              <span class="z-icon z-dropdown-input__icon">
                <z-icon :icon="['far', 'chevron-down']" size="medium" />
              </span>
            </div>
          </label>

          <button
            class="z-button z-button--primary z-button--block"
            :disabled="!installment"
            @click="setupFinished = true"
          >
            Continuar
          </button>
        </div>

        <div v-else-if="creditCard && setupFinished">
          <div class="z-text z-text--bold">
            Detalhes do curso
          </div>

          <div class="z-text">
            <b>Curso:</b>
            {{ currentBilling.course_name }}
          </div>

          <div class="z-text">
            <b>Instituição:</b>
            {{ currentBilling.institution_name }}
          </div>

          <div class="z-divider z-divider--twice spacer-st"></div>

          <div class="z-text z-text--bold">
            Detalhes para pagamento
          </div>

          <div class="z-text">
            <b>Cartão para cobrança:</b>
            {{ creditCard.card_brand | capitalize }} final {{ creditCard.last_digits }}
          </div>

          <div class="z-text spacer-bottom-st">
            <b>Parcelas escolhidas:</b>
            {{ installment }}x de {{ (currentContract.remaining_value / installment) | formatCurrency }}
          </div>

          <button class="z-button z-button--primary z-button--block" @click="submitPayment">
            Confirmar e pagar todo o {{ periodName }}
          </button>
        </div>

        <card-selection
          v-else
          class="spacer-bottom-m"
          card-type="credit_card"
          @cardSelected="selectCard"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AlertBox from 'components/zilla/alert-box';
import Breadcrumb from 'components/breadcrumb';
import CardSelection from 'components/card-selection';
import ContractFullAmount from 'pages/contract-payment/contract-full-amount';
import ContractFullPaymentService from 'services/ContractFullPaymentService';

export default {
  components: {
    AlertBox,
    Breadcrumb,
    CardSelection,
    ContractFullAmount,
  },
  data: () => ({
    creditCard: null,
    installment: null,
    setupFinished: false,
    whatsappNumber: '0800 291 7878',
  }),
  computed: {
    ...mapGetters(['showContractDischarge']),
    ...mapState([
      'student',
      'currentBilling',
      'currentContract',
    ]),
    periodName() {
      return this.currentContract.period_name;
    },
  },
  beforeMount() {
    if (!this.showContractDischarge) {
      this.$router.push({ name: 'panel' });
    }
  },
  methods: {
    selectCard(card) {
      this.$tracker.logEvent('[contract discharge] Selected Credit Card');
      this.creditCard = card;
    },
    submitPayment() {
      const paymentSettings = {
        card_id: this.creditCard.id,
        installments: this.installment,
      };

      this.$tracker.logEvent('[contract discharge] Clicked "Continuar e pagar todo o curso"', {
        installments: this.installment,
      });
      this.charge(paymentSettings);
    },
    charge(paymentSettings) {
      this.$pageLoader.show('Enviando pagamento');

      return ContractFullPaymentService.charge('credit_card', this.currentContract.id, paymentSettings)
        .then(({ request }) => {
          if (request.status === 'refused') {
            this.showRefusedPaymentMessage();
          } else if (request.status === 'paid') {
            this.$router.push({ name: 'contract-payment-success' });
          } else {
            this.showPaymentErrorMessage();
          }
        }).catch((error) => {
          this.$rollbar.error(error);
          this.showPaymentErrorMessage();
        })
        .finally(() => this.$pageLoader.hide());
    },
    showRefusedPaymentMessage() {
      this.$refs.alertBox.show(
        'danger',
        'Erro ao processar o pagamento nesse cartão de crédito',
        'Informe outro cartão.',
      );
    },
    showPaymentErrorMessage() {
      this.$refs.alertBox.show(
        'danger',
        'Não foi possível realizar o pagamento.',
        `Por favor, entre em contato com o Quero Pago pelo Whatsapp: ${this.whatsappNumber}`,
      );
    },
    pluralizeInstallments(number) {
      if (number === 1) return 'parcela';
      return 'parcelas';
    },
  },
};
</script>
